import { getCookie } from 'helpers/VanillaCookie';

function hasNamespaceInCookie(namespace) {
    const namespaces = getCookie('pplus_logger');

    if (typeof namespaces !== 'string') return false;

    return namespaces
        .split(',')
        .map((val) => val.trim().toLowerCase())
        .includes(namespace.toLowerCase());
}

export function createLogger(namespace, enabled = false) {
    const isEnabled = () => {
        if (console && (enabled || hasNamespaceInCookie(namespace))) {
            return true;
        }
        return false;
    };

    return {
        info(...args) {
            if (!isEnabled()) return;
            console.info(`${namespace}:`, ...args);
        },
        error(...args) {
            if (!isEnabled()) return;
            console.error(`${namespace}:`, ...args);
        },
        log(...args) {
            if (!isEnabled()) return;
            console.log(`${namespace}:`, ...args);
        },
    };
}

export default createLogger;
